<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center pa-4">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-account-group</v-icon>
          <h2 class="font-weight-bold">직종별 합계</h2>
        </div>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="mt-0 pt-0">
        <div class="table-container">
          <table class="wage-table">
            <thead>
              <tr>
                <th v-for="header in headers" :key="header.key" :class="{ 'text-end': header.align === 'end' }">
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in jobTotals" :key="index">
                <td class="text-center">{{ item.emp_job }}</td>
                <td class="text-center">{{ item.emp_count }}</td>
                <td class="text-end">{{ item.total }}</td>
                <td class="text-end">{{ item.c_out }}</td>
                <td class="text-end">{{ item.c_total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';

interface JobTotal {
  emp_job: string;
  emp_count: number;
  total: string;
  c_out: string;
  c_total: string;
}

const store = useStore();
const dialog = ref(false);
const loading = ref(false);
const jobTotals = ref<JobTotal[]>([]);

const headers = [
  { title: '직종', key: 'emp_job', align: 'center' },
  { title: '인원', key: 'emp_count', align: 'center' },
  { title: '총액', key: 'total', align: 'center' },
  { title: '퇴직금', key: 'c_out', align: 'center' },
  { title: '공제합계', key: 'c_total', align: 'center' },
];

const fetchJobTotals = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get('/api/wage/job-totals', {
      params: {
        sisul_code: store.state.AdminSisulCode,
        ew_ym: store.state.AdminYYMM
      }
    });
    jobTotals.value = response.data;
    console.log(jobTotals.value,'jobTotals')
  } catch (error) {
    console.error('직종별 합계 조회 중 에러 발생:', error);
  } finally {
    loading.value = false;
  }
};

const openDialog = async () => {
  await fetchJobTotals();
  dialog.value = true;
};

defineExpose({
  openDialog
});
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}

.wage-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
}

.wage-table th,
.wage-table td {
  padding: 12px;
  border: 1px solid #e0e0e0;
}

.wage-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.wage-table tr:hover {
  background-color: #f8f9fa;
}

.text-center {
  text-align: center;
}

.text-end {
  text-align: right;
}
</style>
